import { Button, Modal } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import { IconExpire } from './icons';
import UserService from '../services/UserService';

export default function Session({ children }) {
    const [isTimeOut, setIsTimeOut] = useState(false);

    const timeout = 1800; // 30 minutes

    useEffect(() => {
        let timer;
        const resetTimer = () => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                setIsTimeOut(true);
            }, timeout * 1000);
        };

        const handleActivity = () => {
            if (!isTimeOut) {
                resetTimer();
            }
        };

        window.addEventListener('mousedown', handleActivity);
        window.addEventListener('mouseup', handleActivity);
        window.addEventListener('keydown', handleActivity);
        window.addEventListener('keyup', handleActivity);

        resetTimer();

        return () => {
            clearTimeout(timer);
            window.removeEventListener('mousedown', handleActivity);
            window.removeEventListener('mouseup', handleActivity);
            window.removeEventListener('keydown', handleActivity);
            window.removeEventListener('keyup', handleActivity);
        };
    }, [isTimeOut, timeout]);

    return (
        <Fragment>
            {children}
            <ModalSsExpire open={isTimeOut} setIsTimeOut={setIsTimeOut} />
        </Fragment>
    );
}

const ModalSsExpire = ({ open, setIsTimeOut }) => {
    const { t } = useTranslation();
    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            closable={false}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                <IconExpire />
                <div className="text-2xl font-semibold whitespace-pre-line">
                    {t('Your session has been expired')}
                </div>
                <div className={`whitespace-pre-line text-[#65707A]`}>
                    {parse(t('You will be redirected to Login page'))}
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                <Button
                    onClick={() => {
                        UserService.doLogout();
                        setIsTimeOut(true);
                    }}
                    className="w-36"
                    size="large"
                    type="primary"
                >
                    {t('common.OK')}
                </Button>
            </div>
        </Modal>
    );
};
